import { useReducer, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../db/firebase";

import { ContextUser } from "./context";
import { authReducer } from "./reducer";

const initialState = {
  user: null,
  loading: true,
};

export function ContextUserProvider({ children }: any) {
  const [state, dispatch] = useReducer(authReducer, initialState);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      dispatch({ type: "SET_USER", payload: user });
      dispatch({ type: "SET_LOADING", payload: false });
    });

    return () => unsubscribe();
  }, []);

  return (
    <ContextUser.Provider value={{ state, dispatch }}>
      {children}
    </ContextUser.Provider>
  );
}